import { HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FrameworkAgreementDto, FrameworkAgreementPatchDto, PersonDto } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../common/auth/useLoggedInWithOrgContextState";
import { parseApiFieldErrors, useEditor, useFieldErrorTranslation } from "../../common/editing/save-coordinator";
import { useSaveNow } from "../../common/editing/save-coordinator/useSaveNow";
import { ChangeResponsibleButton } from "../../common/persons/ChangeResponsibleButton";
import { displayPersonName } from "../../common/persons/displayPersonName";

export const ResponsiblePersonName = ({ person }: { person: PersonDto }) => (
  <>{displayPersonName(person).trim() || person.email}</>
);

export const EditableResponsiblePerson = ({ frameworkAgreementId }: { frameworkAgreementId: string }) => {
  const { t } = useTranslation();
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const translateFieldError = useFieldErrorTranslation();
  const { state } = useEditor<FrameworkAgreementDto, FrameworkAgreementPatchDto>(frameworkAgreementId);
  const { saveNow, isSaving } = useSaveNow<FrameworkAgreementDto, FrameworkAgreementPatchDto>(frameworkAgreementId);

  const describeFailure = (error: unknown) => {
    const refusal = parseApiFieldErrors(error)?.get("responsiblePersonId");
    return refusal ? translateFieldError(refusal) : t("The responsible person was not saved. Try again.");
  };

  return (
    <HStack spacing="3">
      <Text as="span">
        <ResponsiblePersonName person={state.responsiblePerson} />
      </Text>
      <ChangeResponsibleButton
        ownerOrgId={selectedOrg.id}
        currentResponsible={state.responsiblePerson}
        capability={null}
        title={String(t("Change responsible person"))}
        ariaLabel={String(t("Change responsible person"))}
        savedMessage={String(t("Responsible person changed"))}
        explanation={t(
          "Choose who is responsible for the framework agreement. Reminders to the responsible person go to this person.",
        )}
        save={(personId) => saveNow({ responsiblePersonId: personId })}
        isSaving={isSaving}
        describeFailure={describeFailure}
      />
    </HStack>
  );
};
